import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { DocumentOrder } from '../_models/documentOrder';
import { environment } from './../../../environments/environment';

@Injectable()
export class DocumentOrderService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getDocumentOrders(): Observable<DocumentOrder[]> {
    return this.http
      .get<DocumentOrder[]>(this.apiBaseUrl + 'api/private/v1/documentOrders')
      .pipe(map((response) => response));
  }

  getDocumentOrder(id: number): Observable<DocumentOrder> {
    return this.http
      .get<DocumentOrder>(this.apiBaseUrl + 'api/private/v1/documentOrders/' + id)
      .pipe(map((response) => response));
  }
}
